module.exports = __webpack_public_path__ + "img/cover.154362cd.jpg";